module.exports = __webpack_public_path__ + "img/product4p.7c38cc3b.png";